export const SOLOMON_ALLOWED_ACTIONS = [
  "send-message",
  "create-task",
  "update-status",
] as const;

export type SolomonAllowedAction = (typeof SOLOMON_ALLOWED_ACTIONS)[number];

const ACTION_ALIASES: Record<string, SolomonAllowedAction> = {
  "compose-message": "send-message",
  "send-thanks": "send-message",
  "send-followup": "send-message",
  "send-welcome": "send-message",
  "send-outreach": "send-message",
  "send-appeal": "send-message",
  "send-deadline-reminders": "send-message",
  "message-batch": "send-message",
  "thank-team": "send-message",
  "start-outreach-campaign": "send-message",
  "schedule-followup": "create-task",
  "start-recurring-task": "create-task",
};

export function normalizeSolomonAction(action: string): SolomonAllowedAction | null {
  if (SOLOMON_ALLOWED_ACTIONS.includes(action as SolomonAllowedAction)) {
    return action as SolomonAllowedAction;
  }

  return ACTION_ALIASES[action] ?? null;
}
